export const AlertVariant = Object.freeze({
  DEFAULT: 'default',
  INLINE: 'inline',
  INLINE_NO_BG: 'inline-no-bg',
  BANNER: 'banner'
} as const);

export type AlertVariant = (typeof AlertVariant)[keyof typeof AlertVariant];
